exports = module.exports = require("../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-index>div {\n  width: 1000px;\n  margin: 0 auto;\n}\n.contact-method {\n  border-top: solid 1px rgba(52,52,52,0.1);\n  padding-top: 28px;\n  font-size: 14px;\n  color: #343434;\n}\n.contact-method>div {\n  margin: 2px 0;\n  line-height: 22px;\n}\n.contact-method>div span {\n  display: inline-block;\n  font-weight: 300;\n  width: 60px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/app/about/contact-us/contact-us.component.styl
// module id = ../../../../../src/app/about/contact-us/contact-us.component.styl
// module chunks = main